import { lazy } from 'react';
import { ContentTestDetail, ContentTestOverview, ContentTestSetup } from '@/pages/ContentTest';
import {
  ToolsHub,
  ToolsCategoryPage,
  PlanPage,
  CreatePage,
  ScalePage,
  DeliverPage,
} from '@/pages/ToolsHub';
import { NACBIntakeFormPage } from '@/pages/NACB';
import { AgentDetail } from './AgentDetail/AgentDetail';
import { AnalysisHome } from './AnalysisHome/AnalysisHome';
import { Analytics } from './Analytics';
import { AudienceDetail } from './AudienceDetail/AudienceDetail';
import { Audiences } from './Audiences/Audiences';
import { FocusGroups } from './FocusGroups';
import { FolderGuidelines } from './FolderGuidelines/FolderGuidelines';
import { HomePageDashboard } from './HomePageDashboard/HomePageDashboard';
import { KnowledgeBase } from './KnowledgeBase/KnowledgeBase';
import { KnowledgeFilesWorkspace as KnowledgeBaseDetail } from '@/features/knowledge-bases/ui/KnowledgeFilesWorkspace';
import { KnowledgeHub } from './KnowledgeHub/KnowledgeHub';
import { MediaConnectors } from './MediaConnectors';
import { NewAnalysis } from './NewAnalysis/NewAnalysis';
import { FocusGroupDetail } from './FocusGroupDetail';
import { NewFocusGroup } from './NewFocusGroup';
import { NewProject } from './NewProject';
import { NotFound } from './NotFound/NotFound';
import { OpportunitiesRoom } from './OpportunitiesRoom';
import { Download } from './Download';
import { TrackerBoard, Trackers } from './Trackers';
import { ProjectDetail } from './ProjectDetail';
import { Projects } from './Projects';
import { Root } from './Root/Root';
import { Sessions } from './Sessions/Sessions';
import { StreamChatSession } from './StreamChatSession/StreamChatSession';
import { VisualGuidelines } from './VisualGuidelines/VisualGuidelines';

// The Content Studio canvas pulls in @xyflow/react and the rest of the pack-editing
// graph, so it stays a separate chunk that flag-off users never fetch.
const ContentStudioPage = lazy(() =>
  import('@/pages/ContentStudio').then((m) => ({ default: m.ContentStudioPage })),
);
const ContentBoardsPage = lazy(() =>
  import('@/pages/ContentBoards').then((m) => ({ default: m.ContentBoardsPage })),
);
// Flag-off users never open Reels Creator, so its sessions home stays out of the entry chunk.
const ReelsCreatorHomePage = lazy(() =>
  import('@/pages/ReelsCreator').then((m) => ({ default: m.ReelsCreatorHomePage })),
);
const ReelsCreatorWizardPage = lazy(() =>
  import('@/pages/ReelsCreator').then((m) => ({ default: m.ReelsCreatorWizardPage })),
);
const ReelsCreatorBrandsPage = lazy(() =>
  import('@/pages/ReelsCreator').then((m) => ({ default: m.ReelsCreatorBrandsPage })),
);
const ReelsCreatorSettingsPage = lazy(() =>
  import('@/pages/ReelsCreator').then((m) => ({ default: m.ReelsCreatorSettingsPage })),
);

export {
  AgentDetail,
  AnalysisHome,
  Analytics,
  AudienceDetail,
  Audiences,
  CreatePage,
  FocusGroupDetail,
  FocusGroups,
  FolderGuidelines,
  HomePageDashboard,
  KnowledgeBase,
  KnowledgeBaseDetail,
  KnowledgeHub,
  MediaConnectors,
  NewAnalysis,
  NewFocusGroup,
  NewProject,
  NotFound,
  OpportunitiesRoom,
  Download,
  TrackerBoard,
  Trackers,
  ProjectDetail,
  Projects,
  Root,
  Sessions,
  StreamChatSession,
  ContentStudioPage,
  ContentTestDetail,
  ContentTestOverview,
  ContentTestSetup,
  ContentBoardsPage,
  ReelsCreatorHomePage,
  ReelsCreatorWizardPage,
  ReelsCreatorBrandsPage,
  ReelsCreatorSettingsPage,
  DeliverPage,
  PlanPage,
  ScalePage,
  ToolsCategoryPage,
  ToolsHub,
  VisualGuidelines,
  NACBIntakeFormPage,
};
